/**
 * Stub method returns nothing
 */
export function noop(...args: any[]): any {}
